// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { productSelectorStyles } from "@synd/Overrides/Components/ProductSelector";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, xScreen, mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.container = {
    css: css`
        display: flex;
        gap: 20px;
        align-items: ${({ hasError }: any) => (hasError ? `center;` : `flex-end;`)};
        flex-wrap: wrap;
        &&& label + ${FormInputWrapper} {
            margin-top: 4px;
        }
    `,
};

productSelectorStyles.qtyGridItem = {
    css: css`
        margin-bottom: ${({ hasError }: any) => (hasError ? `5px;` : `0;`)};
        ${FormFieldStyle} {
            width: 80px;
            input {
                text-align: center;
            }
        }
    `,
};


productSelectorStyles.unitOfMeasureGridItem = {
    css: css`
        margin-bottom: ${({ hasError }: any) => (hasError ? `5px;` : `0;`)};
        ${FormFieldStyle} {
            width: 80px;
            input {
                text-align: center;
            }
        }
        &:empty {
            display: none;
        }
    `,
};

productSelectorStyles.unitOfMeasureSelect = {
    cssOverrides: {
        formField: css`
            width: 90px;
        `,
    },
};

productSelectorStyles.searchGridItem = {
    css: css`
        position: relative;
        flex-basis: 40%;
        ${xScreen("lte", "sm")} {
            flex-basis: 100%;
        }
    `,
};

productSelectorStyles.buttonGridItem = {
    css: css`
        align-self: ${({ hasError }: any) => (hasError ? `center;` : `unset;`)};
    `,
};

productSelectorStyles.selectButton = {
    css: css`
        min-width: 111px;
    `,
};

